import * as React from 'react';
import { Label } from '../Label';
import { Stack } from '../Stack';
import { ProgressIndicator } from '../ProgressIndicator';
import { useZipper } from '../../hooks/useZipper';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Zipper(_ref) {
  let {
    urls,
    fileName,
    onSuccess,
    onError
  } = _ref;
  const {
    zipped,
    error,
    isSuccess
  } = useZipper({
    urls,
    fileName
  });
  React.useEffect(() => {
    if (onSuccess && isSuccess) {
      onSuccess();
    }
  }, [isSuccess]);
  if (error) {
    if (onError) {
      onError(error.message);
    }
    return /*#__PURE__*/_jsx(Stack, {
      children: error.message
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: zipped.map(file => /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsx(Label, {
        children: file
      }), /*#__PURE__*/_jsx(Stack.Item, {
        grow: true,
        children: /*#__PURE__*/_jsx(ProgressIndicator, {
          percentComplete: isSuccess ? 100 : undefined
        })
      })]
    }, file))
  });
}